import {NetworkOutreachDetails, NetworkOutreachDetailsProps} from "./NetworkOutreachDetails";
import { OutreachExportType } from "../export/enumerations";

const Practitioner: React.FC<React.PropsWithChildren<NetworkOutreachDetailsProps>> = (props:NetworkOutreachDetailsProps) => {
  return (    
    <NetworkOutreachDetails {...props} name="Practitioner" exportType={ OutreachExportType.Practitioner }/>
  )
}

export default Practitioner;